module.exports = __webpack_public_path__ + "44803faf9d1021ab1bc42bdc7b251d44.png";